"use client";

import { useState, useMemo, useEffect } from "react";
import { Search } from "lucide-react";
import PageLayout from "../components/ui/PageLayout";

interface AITool {
  id: string;
  name: string;
  description: string;
  icon: string;
  category: string;
  color: string;
}

const aiTools: AITool[] = [
  {
    id: "put-shirt",
    name: "Put shirt on him",
    description: "Ajoutez une chemise à une image de personne",
    icon: "👕",
    category: "Image",
    color: "bg-green-500",
  },
  {
    id: "headshot-gen",
    name: "HeadShot Generator",
    description: "Créez des portraits professionnels instantanément",
    icon: "🧑‍🎨",
    category: "Image",
    color: "bg-purple-500",
  },
  {
    id: "image-fusion",
    name: "Image Fusion",
    description: "Fusionnez plusieurs images en une création unique",
    icon: "🎨",
    category: "Image",
    color: "bg-pink-500",
  },
  {
    id: "reface",
    name: "Reface",
    description:
      "Une appli de remplacement des visages s'appuyant sur l'IA pour obtenir des...",
    icon: "🎭",
    category: "Image",
    color: "bg-purple-500",
  },
  {
    id: "profile-photo",
    name: "ProfilePhoto",
    description: "Créez des photos de profil professionnelles avec l'IA",
    icon: "👤",
    category: "Image",
    color: "bg-gray-500",
  },
  {
    id: "logo-maker",
    name: "Logo Maker",
    description: "Create your brand logo with a simple message",
    icon: "🦁",
    category: "Design",
    color: "bg-gradient-to-br from-purple-600 to-pink-600",
  },
  {
    id: "carousel-studio",
    name: "Carousel Studio",
    description: "Créez des carrousels pour les réseaux sociaux avec l'IA",
    icon: "✨",
    category: "Social",
    color: "bg-purple-400",
  },
  {
    id: "ai-image-gen",
    name: "AI Image Gen",
    description: "Generate images using AI",
    icon: "🎨",
    category: "Image",
    color: "bg-black",
  },
  {
    id: "mojo-ai",
    name: "Mojo AI",
    description: "Ajoutez une touche artistique à vos designs",
    icon: "🎯",
    category: "Design",
    color: "bg-cyan-400",
  },
  {
    id: "gen-logo",
    name: "Gen Logo",
    description: "Concrétisez facilement vos idées de logos grâce à l'IA",
    icon: "🤖",
    category: "Design",
    color: "bg-blue-400",
  },
  {
    id: "background-cleaner",
    name: "Background Cleaner",
    description: "Remove backgrounds instantly",
    icon: "🧹",
    category: "Image",
    color: "bg-pink-400",
  },
  {
    id: "gomme-image",
    name: "Gomme d'image",
    description: "Retirez des personnes ou objets indésirables sur des photos",
    icon: "🗑️",
    category: "Image",
    color: "bg-orange-500",
  },
  {
    id: "effet-magique",
    name: "Effet magique",
    description:
      "Transformez des éléments de votre design en contenu extraordinaire",
    icon: "✨",
    category: "Design",
    color: "bg-green-500",
  },
  {
    id: "ai-chart-maker",
    name: "AI Chart Maker",
    description:
      "Générez facilement des graphiques à partir d'un texte avec l'IA",
    icon: "📊",
    category: "Data",
    color: "bg-red-500",
  },
  {
    id: "ai-headshot-maker",
    name: "AI Headshot Maker",
    description: "Créez des portraits de différents styles à partir de photos",
    icon: "🤳",
    category: "Image",
    color: "bg-gradient-to-br from-pink-500 to-orange-500",
  },
  {
    id: "ai-image-generator",
    name: "AI Image Generator",
    description: "Convertissez du contenu textuel en image à l'aide de l'IA",
    icon: "🖼️",
    category: "Image",
    color: "bg-teal-500",
  },
  {
    id: "ai-image-enhancer",
    name: "AI Image Enhancer",
    description: "Améliorez et restaurez instantanément vos images",
    icon: "🔍",
    category: "Image",
    color: "bg-blue-400",
  },
  {
    id: "logo-gen",
    name: "LogoGen",
    description: "Transformez du texte en logos",
    icon: "💡",
    category: "Design",
    color: "bg-yellow-500",
  },
  {
    id: "mockup-studio",
    name: "Mockup Studio",
    description: "Elevate your brand with unique product images",
    icon: "📱",
    category: "Design",
    color: "bg-gray-600",
  },
  {
    id: "logo-master",
    name: "Logo Master",
    description: "Générez instantanément des logos sur mesure avec l'IA",
    icon: "👨‍🎨",
    category: "Design",
    color: "bg-red-600",
  },
  {
    id: "ai-image-extender",
    name: "AI Image Extender",
    description: "Agrandissez facilement vos images grâce à l'IA",
    icon: "🔄",
    category: "Image",
    color: "bg-purple-600",
  },
  {
    id: "neon-artist",
    name: "NeonArtist",
    description:
      "Générez des œuvres d'art de style néon à partir d'un texte descriptif",
    icon: "🌈",
    category: "Art",
    color: "bg-gradient-to-br from-purple-500 to-pink-500",
  },
  {
    id: "ai-frames",
    name: "AI Frames",
    description: "Créez de splendides cadres à l'aide de l'IA",
    icon: "🖼️",
    category: "Design",
    color: "bg-blue-600",
  },
  {
    id: "text-to-video",
    name: "Text to Video",
    description: "Transform text into engaging videos with AI",
    icon: "🎬",
    category: "Video",
    color: "bg-indigo-500",
  },
  {
    id: "voice-cloner",
    name: "Voice Cloner",
    description: "Clone and generate realistic voices using AI",
    icon: "🎤",
    category: "Audio",
    color: "bg-green-600",
  },
  {
    id: "ai-writer",
    name: "AI Writer",
    description: "Generate high-quality content with advanced AI",
    icon: "✍️",
    category: "Writing",
    color: "bg-amber-500",
  },
  {
    id: "code-assistant",
    name: "Code Assistant",
    description: "AI-powered coding companion for developers",
    icon: "💻",
    category: "Development",
    color: "bg-slate-600",
  },
  {
    id: "music-generator",
    name: "Music Generator",
    description: "Create original music tracks with AI composition",
    icon: "🎵",
    category: "Audio",
    color: "bg-violet-500",
  },
  {
    id: "3d-model-creator",
    name: "3D Model Creator",
    description: "Generate 3D models from text descriptions",
    icon: "🎲",
    category: "3D",
    color: "bg-emerald-500",
  },
  {
    id: "ai-translator",
    name: "AI Translator",
    description: "Translate text between 100+ languages instantly",
    icon: "🌍",
    category: "Language",
    color: "bg-sky-500",
  },
  {
    id: "presentation-maker",
    name: "Presentation Maker",
    description: "Create stunning presentations with AI assistance",
    icon: "📊",
    category: "Productivity",
    color: "bg-orange-600",
  },
  {
    id: "ai-chatbot",
    name: "AI Chatbot",
    description: "Build intelligent conversational AI assistants",
    icon: "🤖",
    category: "AI",
    color: "bg-cyan-600",
  },
];

const categories = [
  "All",
  "Image",
  "Design",
  "Video",
  "Audio",
  "Writing",
  "Development",
  "Data",
  "Social",
  "Utility",
  "Art",
  "3D",
  "Language",
  "Productivity",
  "AI",
];

export default function AIToolsPage() {
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedCategory, setSelectedCategory] = useState("All");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const filteredTools = useMemo(() => {
    return aiTools.filter((tool) => {
      const matchesSearch =
        tool.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
        tool.description.toLowerCase().includes(searchTerm.toLowerCase());
      const matchesCategory =
        selectedCategory === "All" || tool.category === selectedCategory;
      return matchesSearch && matchesCategory;
    });
  }, [searchTerm, selectedCategory]);

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-950 via-purple-950 to-slate-900 text-white">
      <PageLayout>
        {/* Header */}
        <div className="mb-8">
          <h1 className="text-3xl md:text-5xl font-bold bg-gradient-to-r from-purple-400 to-pink-400 bg-clip-text text-transparent mb-4">
            AI Tools Collection
          </h1>
          <p className="text-gray-400 text-lg max-w-2xl">
            Discover powerful AI tools to enhance your creativity, productivity,
            and workflow. From image generation to code assistance.
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-8">
          <div className="relative max-w-md">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-4 w-4" />
            <input
              type="text"
              placeholder="Search AI tools..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="w-full pl-10 pr-4 py-2 bg-slate-800/50 border border-slate-700 rounded-md text-white placeholder-gray-400 focus:border-purple-400 focus:outline-none focus:ring-1 focus:ring-purple-400"
            />
          </div>
        </div>

        {/* Category Filter */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-2">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-colors ${
                  selectedCategory === category
                    ? "bg-purple-600 text-white"
                    : "bg-slate-800/50 text-gray-300 hover:bg-slate-700/50"
                }`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>

        {/* Tools Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          {filteredTools.map((tool) => (
            <div
              key={tool.id}
              className="bg-slate-800/50 border border-slate-700 rounded-lg hover:bg-slate-800/70 transition-colors cursor-pointer group"
            >
              <div className="p-4">
                <div className="flex items-start gap-4">
                  <div
                    className={`w-12 h-12 rounded-lg ${tool.color} flex items-center justify-center text-2xl flex-shrink-0`}
                  >
                    {tool.icon}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="font-semibold text-white mb-1 group-hover:text-purple-300 transition-colors">
                      {tool.name}
                    </h3>
                    <p className="text-gray-400 text-sm leading-relaxed">
                      {tool.description}
                    </p>
                    <div className="mt-2">
                      <span className="inline-block px-2 py-1 bg-slate-700/50 text-xs text-gray-300 rounded">
                        {tool.category}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* No Results */}
        {filteredTools.length === 0 && (
          <div className="text-center py-12">
            <div className="text-gray-400 mb-4">
              <Search className="w-16 h-16 mx-auto mb-4 opacity-50" />
            </div>
            <h3 className="text-xl font-semibold text-white mb-2">
              No tools found
            </h3>
            <p className="text-gray-400">
              Try adjusting your search terms or category filter
            </p>
          </div>
        )}
      </PageLayout>
    </div>
  );
}
